// FILECONTENT_START src/common/components/AvatarMenu/index.ts
import AvatarMenu from "./AvatarMenu";
export default AvatarMenu;
export type { AvatarMenuProps } from "./AvatarMenu";

// FILECONTENT_END src/common/components/AvatarMenu/index.ts